import { environment } from '@vaki/shared/util/environment';

/**
 * Single mutable source of truth for AC8 (kill switch) and AC2 (adjustable
 * sampling), read by `sentry-browser.init.ts`'s `beforeSend` on every
 * single event. Deliberately NOT the Sentry SDK's own `sampleRate` init
 * option — that's fixed at `Sentry.init()` time, before Angular's
 * injector (and therefore Remote Config) exists. This object starts out
 * holding the local, build-time defaults and gets updated in place once
 * `ErrorTrackingRuntimeConfigService` subscribes to Remote Config after
 * bootstrap (see wire-error-tracking-runtime.ts) — the same "local
 * default until RC resolves, then live" trade-off `ErrorTrackingRuntimeConfigService`
 * already documents.
 *
 * A plain mutable module singleton, not a service: `beforeSend` is a bare
 * closure handed to `Sentry.init()` at pre-bootstrap, DI-free module
 * scope, so it cannot `inject()` anything. This is the same reason
 * `wire-error-tracking-runtime.ts` exists as a separate post-bootstrap
 * step instead of one single init function.
 */
export const errorTrackingRuntimeState = {
  killSwitchActive: false,
  sampleRate: environment.sentry.sampleRate
};
